import Api from "../../Api";
import { modifyError } from "../../Validation/ModifyErrros";

export const getDestinationData = async (query) => {
    try {
      let res = await Api.get("/destinations", {
        params: query,
      });
    
      return res?.data || [];
    } catch (e) {
      let error = modifyError(e);
      return { error: error.message };
    }
  };

  export const getDestinatinDataLocation = async (query) => {
    try {
      let res = await Api.get("/destinations/location", {
        params: query,
        headers:{
          "Authorization": `Bearer ${localStorage.getItem("token")}`
        }
      });
    
      return res?.data || [];
    } catch (e) {
      return { error: "Something Wrong" };
    }
  };

  export const getDestinationDataById = async (id) => {
    try {
      let res = await Api.get("/destinations/"+id)
    
      return res?.data || [];
    } catch (e) {
      return { error: "Something Wrong" };
    }
  };

  export const createDestination = async (data) => {

    try {
      let res = await Api.post("/destinations", data);
      return res?.data;
    } catch (e) {
      let error = modifyError(e);
      return { error: error.message };
    }
  };

  export const updateDestination = async (id, data) => {
    try {
      let res = await Api.patch("/destinations/" + id, data);
    
      return res?.data || [];
    } catch (e) {
      let error = modifyError(e);
      return { error: error.message };
    }
  };


export const deleteDestinationData = async (id) => {
  try {
    let res = await Api.delete("/destinations/" + id);
  
    return res?.data || [];
  } catch (e) {
    return { error: "Failed to delete" };
  }
};

export const cleanupDestinationImages = async (fileNames) => {
  if (!fileNames || fileNames.length === 0) return;
  try {
    await Api.post("/destinations/cleanup-images", { fileNames });
  } catch (e) {
    // Best-effort cleanup — a failure here shouldn't block the save that already succeeded.
  }
};

export const updatePosition = async(destinations, query)=>{
  try {
    let res = await Api.patch("/destinations/relocate-position",destinations, {
      params:query
    });
  
    
    return res?.data || [];
  } catch (e) {
    let error = modifyError(e);
    return { error: error.message };
  }
}